// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_benefits_benefits_module_ts":"b9cefefe6d4ee5a0","node_modules_dompurify_dist_purify_js":"bbf56e1741fe91f8","node_modules_canvg_lib_index_es_js":"1921e740cb6cd17e"}[chunkId] + ".js";
};